(function () {
    'use strict';

    angular.module('app.shared.modals', [


    ]);

})();